import FieldConfig from "../../../../proto/field-config";
import Task from "../../../../../model2/task/task";
import FieldUser from "../../../../generic/user/user";

export default class FieldTaskCreatedBy extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-user-created'
        this.label      = 'Created by'
    }

    canEdit(model:Task):boolean {
        return false
    }
}
